/* eslint-disable import/no-cycle */
import React from 'react';
import { WrappedFunctionProps } from '../types';
import { TextField as FormTextField } from '../../apiForm/form/input';

export default function TextField({
  inputKey,
  translation,
  language,
  control,
}: WrappedFunctionProps) {
  return (
    <FormTextField
      control={control}
      name={inputKey}
      label={translation?.title?.[language] || inputKey}
      helperText={translation?.description?.[language]}
    />
  );
}
